"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var reselect_1 = require("reselect");

var constants_1 = require("../constants");

exports.getApplicationsList = function (applicationsList) {
  return applicationsList || [];
};

exports.getApplications = reselect_1.createSelector(exports.getApplicationsList, function (applications) {
  return applications.filter(function (_ref) {
    var name = _ref.name;
    return name !== null;
  });
});
exports.getActiveApplications = reselect_1.createSelector(exports.getApplications, function (applications) {
  return applications.filter(function (_ref2) {
    var status = _ref2.status;
    return status === constants_1.APP_STATUS.ACTIVE;
  });
});
exports.hasConnectedApplications = reselect_1.createSelector(exports.getActiveApplications, function (applications) {
  return applications.length > 0;
});
exports.getApplication = reselect_1.createSelector(exports.getApplicationsList, function (_, id) {
  return id;
}, function (applications, appId) {
  return applications.find(function (_ref3) {
    var id = _ref3.id;
    return id === appId;
  });
});